import {JwtPayload} from "jwt-decode";

export interface FSCockpitJwtPayload extends JwtPayload {
    roles: string[]
}

export const SPECIAL_SALES_ROLE = "ROLE_TEST_USER";